import { NumClaimsOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { NumCustomerClaimsState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/num-customer-claims";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const NumCustomerClaimsDetails = memo(function NumCustomerClaimsDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<NumCustomerClaimsState>) {
  const claimOptions: RedoListItem<NumClaimsOption>[] = useMemo(
    () =>
      Object.values(NumClaimsOption).map((option) => ({
        id: option,
        value: option,
        type: "text" as const,
        text: option,
      })),
    [],
  );

  const selectedOption = state.claimOption
    ? claimOptions.find((option) => option.value === state.claimOption)
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label="Comparison"
        options={claimOptions}
        optionSelected={({ item }) =>
          setState({ ...state, claimOption: item.value })
        }
        placeholder="Select comparison..."
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        label="Number of claims"
        min={0}
        onBlur={() =>
          setState({ ...state, numClaims: (+state.numClaims).toFixed(0) })
        }
        setValue={(e) =>
          setState({
            ...state,
            numClaims: e,
            claimOption: state.claimOption || null,
          })
        }
        state={disabled ? "readonly" : "default"}
        value={state.numClaims}
      />
    </>
  );
});
